import "./App.css";
import { ChakraProvider } from "@chakra-ui/react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import ManiPediInfo from "./pages/ManiPediInfo";
import { ActiveLinkProvider } from "./pages/ActiveLinkContext"; // Adjust the path as needed

function App() {
  return (
    <ChakraProvider>
      <ActiveLinkProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/spa-manicure-pedicure" element={<ManiPediInfo />} />
          </Routes>
        </Router>
      </ActiveLinkProvider>
    </ChakraProvider>
  );
}

export default App;
